import {
  AI_TUTOR,
  ASSESSMENT_TYPE_AI_TUTOR,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";

export const FILTER_NAME_ACADEMIC_YEAR = "academicYears";
export const FILTER_NAME_SEARCH_TEXT = "searchText";
export const FILTER_NAME_SUBJECT_GROUPS = "subjectGroups";
export const FILTER_NAME_GRADES = "grades";
export const FILTER_NAME_COURSES = "learningCourses";
export const FILTER_NAME_CREATORS = "createdBy";
export const FILTER_NAME_POST_TYPE = "types";
export const FILTER_NAME_POST_ASSESSMENT_TYPE = "assessmentTypes";
export const FILTER_NAME_SUBJECTS = "subjects";
export const FILTER_NAME_CONTENT_TYPE = "content";
export const FILTER_NAME_CLASSES = "classes";
export const FILTER_NAME_WORKSHEET_FILTERS = "worksheetFilters";
export const FILTER_NAME_IB_THEMES = "ibThemes";
export const FILTER_NAME_SCHOOLS = "schools";

export const UNIT_TYPE_INTERDISCIPLINARY = "interdisciplinary";
export const UNIT_TYPE_SUBJECT_SPECIFIC = "subject_specific";

export const UNIT_TYPE_CURRICULUM_PROGRAM_TYPE_MAPPING = {
  [CURRICULUM_TYPE_PYP]: {
    [UNIT_TYPE_INTERDISCIPLINARY]: "ibInquiry",
    [UNIT_TYPE_SUBJECT_SPECIFIC]: "ibStandAlone",
  },
  [CURRICULUM_TYPE_MYP]: {
    [UNIT_TYPE_INTERDISCIPLINARY]: "ibMYPInterdisciplinary",
    [UNIT_TYPE_SUBJECT_SPECIFIC]: "ibMYPSubjectSpecific",
  },
  [CURRICULUM_TYPE_DP]: {
    [UNIT_TYPE_SUBJECT_SPECIFIC]: "ibDPSubjectSpecific",
  },
  [CURRICULUM_TYPE_UBD]: {
    [UNIT_TYPE_INTERDISCIPLINARY]: "ubdInquiry",
    [UNIT_TYPE_SUBJECT_SPECIFIC]: "ubdSubjectSpecific",
  },
};

export const ENUM_TYPE_LEARNING_ENGAGEMENT = "LEARNING_ENGAGEMENT";
export const ENUM_TYPE_ASSESSMENT = "ASSESSMENT";
export const ENUM_TYPE_WORKSHEET = "WORKSHEET";
export const ENUM_TYPE_QUICK_TASK = "QUICK_TASK";

export const POST_TYPE_FILTER_MAPPING = {
  ["LEARNING_ENGAGEMENT_MYP"]: {
    enumType: ENUM_TYPE_LEARNING_ENGAGEMENT,
    assessmentType: "le",
  },
  ["FORMATIVE_ASSESSMENT_MYP"]: {
    enumType: ENUM_TYPE_ASSESSMENT,
    assessmentType: "fmt",
  },
  ["SUMMATIVE_ASSESSMENT_MYP"]: {
    enumType: ENUM_TYPE_ASSESSMENT,
    assessmentType: "smt",
  },
  ["FORMATIVE_ASSESSMENT_PYP"]: {
    enumType: ENUM_TYPE_ASSESSMENT,
    assessmentType: "fmt",
  },
  ["SUMMATIVE_ASSESSMENT_PYP"]: {
    enumType: ENUM_TYPE_ASSESSMENT,
    assessmentType: "smt",
  },
  ["LEARNING_ENGAGEMENT_UBD"]: {
    enumType: ENUM_TYPE_LEARNING_ENGAGEMENT,
  },
  ["ASSESSMENT_UBD"]: {
    enumType: ENUM_TYPE_ASSESSMENT,
  },
  ["WORKSHEET"]: {
    enumType: ENUM_TYPE_WORKSHEET,
    assessmentType: "worksheet",
  },
  ["WORKSHEET_UBD"]: {
    enumType: ENUM_TYPE_WORKSHEET,
  },
  ["LEARNING_ENGAGEMENT"]: {
    enumType: ENUM_TYPE_LEARNING_ENGAGEMENT,
    assessmentType: "le",
  },
  ["QUICK_TASK"]: {
    enumType: ENUM_TYPE_QUICK_TASK,
    assessmentType: "qt",
  },
  ["QUICK_TASK_UBD"]: {
    enumType: ENUM_TYPE_QUICK_TASK,
  },
  [AI_TUTOR]: {
    enumType: AI_TUTOR,
    assessmentType: ASSESSMENT_TYPE_AI_TUTOR,
  },
  ["AI_TUTOR_UBD"]: {
    enumType: AI_TUTOR,
  },
};
export const FILTER_NAME_UNIT_TYPE = "unitTypes";
export const THEATRE_VIEW_NAVIGATION_EVENT = "THEATRE_VIEW_NAVIGATION_EVENT";
export const THEATRE_VIEW_KEYBOARD_NAVIGATION =
  "THEATRE_VIEW_KEYBOARD_NAVIGATION";
export const THEATRE_VIEW_UI_BUTTON_NAVIGATION =
  "THEATRE_VIEW_UI_BUTTON_NAVIGATION";

export const PLANNING_DISABLED_ITEMS = [
  "UNIT_LIBRARY",
  "LE_LIBRARY_PYP",
  "LE_LIBRARY_MYP",
  "LE_LIBRARY_UBD",
  "LE_LIBRARY_DP",
  "DP_SUBJECT_STANDARD",
  "MYP_LEARNING_STANDARDS",
  "UBD_LEARNING_STANDARDS",
  "SCOPE_SEQUENCE",
];
